var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"game-container"},[_c('div',{attrs:{"id":"game"}}),_c('GameUIContainer'),_c('Popup',{staticClass:"hard-error",attrs:{"isActive":_vm.isErrorPopupActive,"canClose":false}},[_c('Error',{attrs:{"content":_vm.hardErrorMessage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }